export const AVATAR_MEDIA_TYPES = [
  "image/png",
  "image/jpeg",
  "image/webp",
] as const;
export type AvatarMediaType = (typeof AVATAR_MEDIA_TYPES)[number];

export function isAvatarMediaType(
  mediaType: string
): mediaType is AvatarMediaType {
  return (AVATAR_MEDIA_TYPES as readonly string[]).includes(mediaType);
}

// Legacy keys carry the media type as an extension; newer keys are plain
// attachment-upload ids whose type is sniffed from the stored bytes.
export const AVATAR_KEY_REGEX = /^[a-zA-Z0-9_-]+(\.(png|jpg|webp))?$/;

export function isValidAvatarKey(key: string): boolean {
  return AVATAR_KEY_REGEX.test(key);
}
